import { Identified } from '@faro/realtime-services';

const pendingSymbol = Symbol('pending');
let pendingId = 0;

/**
 * Create a pending or optimistic object
 * @param value The object properties
 */
export function pending<T extends object>(value: T): T & Identified {
    const clone = structuredClone(value) as any;
    clone.id = `pending_${pendingId++}`;
    clone[pendingSymbol] = true;
    return clone;
}

/**
 * Check if a given model is pending or created optimistically
 * @param value
 */
export function isPending(value: unknown): boolean {
    return value != null && typeof value === 'object' && (value as any)[pendingSymbol];
}
